// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import store from './store'
import './assets/js/filter'
import './assets/js/validate'
import VueMask from 'v-mask'
Vue.use(VueMask)

let baseUrl = ''
if (location.hostname === 'bizdevbackup.haezoom.com') {
  baseUrl = location.hostname.replace('bizdevbackup', 'apidev')
} else {
  baseUrl = location.hostname.replace('biz', 'api')
}

// axios 기본 URL 설정
axios.defaults.baseURL = location.protocol + '//' + baseUrl

// 저장된 토큰이 있을 경우, axios 헤더에 설정.
const token = localStorage.getItem('_t')
if (token) {
  axios.defaults.headers.common['Authorization'] = 'JWT ' + token
}

Vue.config.productionTip = false
Vue.prototype.$http = axios

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router: router,
  created: function () {
    window.Vue = this

    // 인터넷 익스플로러 접속시 크롬 다운로드 페이지 로딩. 모바일은 어쩔?
    if (navigator.userAgent.toLowerCase().indexOf('msie') !== -1) {
      window.location = '/upgrade/'
    }
  },
  render: h => h(App)
})

// 인싸력 증가 아이템
console.log('%c bizHAEZOOM', 'font-weight: bold; font-size: 50px; color: #FF7133; text-shadow: 3px 3px 0 rgb(217,31,38) , 6px 6px 0 rgb(226,91,14) , 9px 9px 0 rgb(245,221,8) , 12px 12px 0 rgb(5,148,68) , 15px 15px 0 rgb(2,135,206) , 18px 18px 0 rgb(4,77,145) , 21px 21px 0 rgb(42,21,113)')
console.log('%c >>> https://www.haezoom.com/recruit/', 'color: #39496B')



// WEBPACK FOOTER //
// ./src/main.js